export default "__VITE_ASSET__9XT3UtAY__"